<template>
  <div class="info-banner" :class="`info-banner--${type}`">
    <div class="info-banner__text">
      <div class="info-banner__text_title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div
        v-if="subtitle || $slots.subtitle"
        class="info-banner__text_subtitle"
      >
        <slot name="subtitle">
          {{ subtitle }}
        </slot>
      </div>
      <div
        v-if="additional || $slots.additional"
        class="info-banner__text_additional"
      >
        <slot name="additional">
          {{ additional }}
        </slot>
      </div>
    </div>
    <div class="info-banner__action">
      <slot name="action"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "negative",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    additional: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.info-banner {
  font-family: Roboto-Regular;
  padding: 15px 15px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;

  &--positive {
    color: white;
    background-color: $colorLightGreen;
  }

  &--neutral {
    color: $colorGreyishBrown;
    background-color: white;
  }

  &--negative {
    color: white;
    background-color: black;
    border-bottom: 1px solid white;
    height: 64px;
  }

  &__text {
    flex: 1;
    text-align: left;

    &_title {
      font-size: 17px;
      line-height: 20px;
    }

    &_subtitle {
      margin-top: 5px;
      font-size: 12px;
      line-height: 14px;
    }

    &_additional {
      margin-top: 5px;
      font-size: 32px;
      line-height: 1.2;
    }
  }
}
</style>
